var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.153 4.62c.245-.523.77-.857 1.347-.857h21.875a1.488 1.488 0 0 1 1.166 2.41l-7.99 10.095V24.5a1.488 1.488 0 0 1-2.976 0v-8.75c0-.335.113-.66.321-.923l6.404-8.09H6.676l6.717 8.06c.223.268.345.605.345.953V21a1.488 1.488 0 0 1-2.975 0V16.29L2.357 6.202a1.488 1.488 0 0 1-.204-1.583z", fill: "#747474" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.063 17.063H12.25v-2.625h4.813v2.624z", fill: "#747474" })
  );
});